import {skipToken} from '@reduxjs/toolkit/query';
import {isFeatureEnabled} from 'feature-flags';

import {isNotNil, uniq, uniqBy} from 'ramda';

import {useGetTrimLevelsQuery} from '@dms/api/sales';
import {featureFlags} from '@dms/feature-flags';

import {useFilters} from '../components/FiltersContext/FiltersContext';
import {useMakeModelFilter} from './useMakeModelFilter';

export function useTrimLevelOptions(isActive = true) {
  const {filters} = useFilters();
  const {getModel, isLoading: isCatalogueLoading} = useMakeModelFilter();
  const models = (filters.model ?? []).map(getModel).filter(isNotNil);
  const selections = uniq([...(filters.make ?? []), ...models.map((model) => model.make)])
    .sort()
    .map((make) => ({
      make,
      // Sourcing calls MODELFAMILY keys models; modelFamily is their optional family group.
      modelFamilies: uniq(
        models.filter((model) => model.make === make).map((model) => model.name)
      ).sort(),
    }));
  const isEnabled = isFeatureEnabled(featureFlags.SOURCING_FILTER_REDESIGN);
  const query = useGetTrimLevelsQuery(
    isEnabled && isActive && selections.length > 0 && !isCatalogueLoading ? selections : skipToken
  );
  const options = uniqBy(
    (option) => option.value,
    [
      ...(query.currentData ?? []),
      ...(filters.trimLevels ?? []).map((value) => ({value, label: value})),
    ]
  );

  return {
    options,
    hasMake: selections.length > 0,
    isLoading: isCatalogueLoading || query.isFetching,
    isError: query.isError,
    retry: query.refetch,
  };
}
